import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";

const Home = () => {
  const [counterOn, setConterOn] = useState(false);
  return (
    <>
      {/* section main 1*/}
      <div
        id="carouselExampleFade"
        className="carousel slide carousel-fade"
        data-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 offset-lg-2 text-center py-5">
                  <h1 className="animate__animated animate__backInDown animate__delay-1s">
                    DELICIOUSBAKERYITEMS
                  </h1>
                  <h1 className="animate__animated animate__backInLeft animate__delay-2s">
                    COCONUT WITH
                    <strong style={{ color: "#e25111", fontFamily: "i" }}>
                      {" "}
                      LEMON GRASS
                    </strong>
                  </h1>
                  <p className="lead animate__animated animate__backInRight animate__delay-3s">
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Ratione quam nesciunt officiis molestiae error? Sequi alias
                    expedita odit labore reiciendis!
                  </p>
                  <div className="lead animate__animated animate__backInUp animate__delay-4s">
                    <button className="btn-more">LEARN MORE</button>
                    <button className="btn-now">ORDER NOW</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <div className="container">
              <div className="row">
                <div className="col-lg-6"></div>
                <div className="col-lg-6  text-right py-5">
                  <h1 className="animate__animated animate__bounceInDown animate__delay-1s">
                    WEPREPARE
                  </h1>
                  <h1 className="animate__animated animate__bounceIn animate__delay-2s">
                    FRESH FOOD
                    <strong style={{ color: "#e25111", fontFamily: "i" }}>
                      {" "}
                      VEGIES
                    </strong>
                  </h1>
                  <p className="lead animate__animated animate__bounceInLeft animate__delay-3s">
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Ratione quam nesciunt officiis molestiae error? Sequi alias
                    expedita odit labore reiciendis!
                  </p>
                  <div className="lead animate__animated animate__bounceInUp animate__delay-4s">
                    <button className="btn-now">ORDER NOW</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 offset-lg-2 text-center py-5">
                  <h1 className="animate__animated animate__flipInX animate__delay-1s">
                    YES WEHAVE
                  </h1>
                  <h1 className="animate__animated animate__flipInY animate__delay-2s">
                    THE BEST FISH
                    <strong style={{ color: "#e25111", fontFamily: "i" }}>
                      {" "}
                      STEAK
                    </strong>
                  </h1>
                  <p className="lead animate__animated animate__lightSpeedInRight animate__delay-3s">
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Ratione quam nesciunt officiis molestiae error? Sequi alias
                    expedita odit labore reiciendis!
                  </p>
                  <div className="animate__animated animate__rotateInUpLeft animate__delay-4s">
                    <button className="btn-now">ORDER NOW</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-target="#carouselExampleFade"
          data-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          {/* <span className="sr-only">Previous</span> */}
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-target="#carouselExampleFade"
          data-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          {/* <span className="sr-only">Next</span> */}
        </button>
      </div>
      {/* section */}
      {/* section  2 */}
      <h1 className="text-center pt-4">OUR SPECIALITIES</h1>
      <hr className="style-eight w-50 mx-auto" />
      {/* Services 3*/}
      <section className="sec2">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 text-center">
              <div className="service">
                <i className="bi bi-cup-hot"></i>
                <h4 className="py-2">Dinner & Dessert</h4>
                <p>
                  you need a doctor for to consectetuer Lorem ipsum dolor,
                  consectetur adipiscing onsectetur.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 text-center">
              <div className="service">
                <i className="bi bi-amd"></i>
                <h4 className="py-2">Breakfast</h4>
                <p>
                  you need a doctor for to consectetuer Lorem ipsum dolor,
                  consectetur adipiscing onsectetur.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 text-center">
              <div className="service">
                <i className="bi bi-cup-straw"></i>
                <h4 className="py-2">Ice Shakes</h4>
                <p>
                  you need a doctor for to consectetuer Lorem ipsum dolor,
                  consectetur adipiscing onsectetur.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 text-center">
              <div className="service">
                <i className="bi bi-cup-straw"></i>
                <h4 className="py-2">Beverges</h4>
                <p>
                  you need a doctor for to consectetuer Lorem ipsum dolor,
                  consectetur adipiscing onsectetur.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* section */}
      {/* Section 4*/}
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <h1 className="i">Featured Food</h1>
            <hr />
            <OwlCarousel items={2} className="owl-theme" loop nav margin={8}>
              <div>
                <img className="img-fluid" src={"assets/img/c1.jpeg"} />
                <h3 className="p">Lorem, ipsum.</h3>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque
                  porro eveniet quam? Esse perspiciatis soluta iusto laborum ea
                  vitae dolorem.
                </p>
              </div>
              <div>
                <img className="img-fluid" src={"assets/img/c2.jpeg"} />
                <h3 className="p">Lorem, ipsum.</h3>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque
                  porro eveniet quam? Esse perspiciatis soluta iusto laborum ea
                  vitae dolorem.
                </p>
              </div>
              <div>
                <img className="img-fluid" src={"assets/img/c3.jpeg"} />
                <h3 className="p">Lorem, ipsum.</h3>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque
                  porro eveniet quam? Esse perspiciatis soluta iusto laborum ea
                  vitae dolorem.
                </p>
              </div>
              <div>
                <img className="img-fluid" src={"assets/img/c4.jpeg"} />
                <h3 className="p">Lorem, ipsum.</h3>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque
                  porro eveniet quam? Esse perspiciatis soluta iusto laborum ea
                  vitae dolorem.
                </p>
              </div>
            </OwlCarousel>
          </div>
          <div className="col-lg-4">
            <h1 className="i">Our Menu</h1>
            <hr />
            <h6 className="or p-2">
              Classic Nachos <span style={{ float: "right" }}>$249.00</span>
            </h6>
            <h6 className="p-2">
              Nachos Grande <span style={{ float: "right" }}>$499.00</span>
            </h6>
            <h6 className="or p-2">
              Avocado Shell Stuffed
              <span style={{ float: "right" }}>$150.00</span>
            </h6>
            <h6 className="p-2">
              Stuffed Mushroom <span style={{ float: "right" }}>$199.00</span>
            </h6>
            <h6 className="or p-2">
              Baked Potato Jackets
              <span style={{ float: "right" }}>$99.00</span>
            </h6>
            <h6 className="p-2">
              Mexican Taco <span style={{ float: "right" }}>$899.00</span>
            </h6>
            <h6 className="or p-2">
              Tex-Mex Chicken<span style={{ float: "right" }}>$1250.00</span>
            </h6>
            <h6 className="p-2">
              Quesadillas Acapulco
              <span style={{ float: "right" }}>$399.00</span>
            </h6>
            <h1>Other Special Menu</h1>
            <p>
              Duis autem vel eum iriure dolor in hendrerit in vulputate velit
              esse <strong>molestie consequat,</strong> vel illum dolore nulla
              facilisis. vel illum dolore nulla facilisis. vel illum dolore
              nulla facilisis.
            </p>
          </div>
        </div>
      </div>
      {/* section */}
      {/* Section HOT Deal of the Day Start */}
      <section className="section5">
        <h1 className="text-white">HOT Deal of the Day Start</h1>
        <p className="col-lg-6 text-white lead offset-lg-3">
          Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse
          molestie consequat, vel illum dolore nulla facilisis. velit esse
          molestie consequat, vel illum dolore nulla facilisis.
        </p>

        <button className="btn-now">ORDER NOW</button>
      </section>
      {/* Section HOT Deal of the Day End */}
      {/* Section Delicious Food Start */}
      <section className="counter">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="counterbox text-center">
                <i className="bi bi-emoji-smile"></i>
                <h1>
                  <ScrollTrigger
                    onEnter={() => setConterOn(true)}
                    onExit={() => setConterOn(false)}
                  >
                    {counterOn && (
                      <CountUp
                        className="i co"
                        start={0}
                        end={4680}
                        duration={2}
                        delay={0}
                      />
                    )}{" "}
                    <span className="text-white">+</span>
                  </ScrollTrigger>
                </h1>
                <h2>Happy Customers</h2>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="counterbox text-center">
                <i className="bi bi-ticket"></i>
                <h1>
                  <ScrollTrigger
                    onEnter={() => setConterOn(true)}
                    onExit={() => setConterOn(false)}
                  >
                    {counterOn && (
                      <CountUp
                        className="i co"
                        start={0}
                        end={865}
                        duration={2}
                        delay={0}
                      />
                    )}{" "}
                    <span className="text-white">+</span>
                  </ScrollTrigger>
                </h1>
                <h2>Dishes Served</h2>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="counterbox text-center">
                <i className="bi bi-cup-straw"></i>
                <h1>
                  <ScrollTrigger
                    onEnter={() => setConterOn(true)}
                    onExit={() => setConterOn(false)}
                  >
                    {counterOn && (
                      <CountUp
                        className="i co"
                        start={0}
                        end={510}
                        duration={2}
                        delay={0}
                      />
                    )}{" "}
                    <span className="text-white">+</span>
                  </ScrollTrigger>
                </h1>
                <h2>Total Beverages</h2>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="counterbox text-center">
                <i className="bi bi-cup-hot"></i>
                <h1>
                  <ScrollTrigger
                    onEnter={() => setConterOn(true)}
                    onExit={() => setConterOn(false)}
                  >
                    {counterOn && (
                      <CountUp
                        className="i co"
                        start={0}
                        end={1350}
                        duration={2}
                        delay={0}
                      />
                    )}
                    {""} <span className="text-white">+</span>
                  </ScrollTrigger>
                </h1>
                <h2>Cup Of Coffees</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Section Delicious Food End */}
      {/* Section Our Kitchen Staff Start */}
      <section className="staff">
        <div className="container">
          <h1>Our Kitchen Staff</h1>
          <hr />
          <OwlCarousel className="owl-theme" items={3} loop margin={10} nav>
            <div className="item">
              <div className="card p-3">
                <img
                  src="assets/img/10.jpeg"
                  className="img-thumbnail"
                  alt=""
                  srcset=""
                />
                <h3 className="pt-2 bf">Stafeny Rose</h3>
                <small>Food Supervisor</small>
                <p className="pt-3">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam
                  sit autem dolore odit, molestias quia?
                </p>
              </div>
            </div>
            <div className="item">
              <div className="card p-3">
                <img src="assets/img/11.jpeg" alt="" srcset="" />
                <h3 className="pt-2 bf">Stafeny Rose</h3>
                <small>Food Supervisor</small>
                <p className="pt-3">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam
                  sit autem dolore odit, molestias quia?
                </p>
              </div>
            </div>
            <div className="item">
              <div className="card p-3">
                <img src="assets/img/12.jpeg" alt="" srcset="" />
                <h3 className="pt-2 bf">Stafeny Rose</h3>
                <small>Food Supervisor</small>
                <p className="pt-3">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam
                  sit autem dolore odit, molestias quia?
                </p>
              </div>
            </div>
            <div className="item">
              <div className="card p-3">
                <img src="assets/img/10.jpeg" alt="" srcset="" />
                <h3 className="pt-2 bf">Stafeny Rose</h3>
                <small>Food Supervisor</small>
                <p className="pt-3">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam
                  sit autem dolore odit, molestias quia?
                </p>
              </div>
            </div>
            <div className="item">
              <div className="card p-3">
                <img src="assets/img/11.jpeg" alt="" srcset="" />
                <h3 className="pt-2 bf">Stafeny Rose</h3>
                <small>Food Supervisor</small>
                <p className="pt-3">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam
                  sit autem dolore odit, molestias quia?
                </p>
              </div>
            </div>
            <div className="item">
              <div className="card p-3">
                <img src="assets/img/12.jpeg" alt="" srcset="" />
                <h3 className="pt-2 bf">Stafeny Rose</h3>
                <small>Food Supervisor</small>
                <p className="pt-3">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam
                  sit autem dolore odit, molestias quia?
                </p>
              </div>
            </div>
          </OwlCarousel>
        </div>
      </section>
      {/* Section Our Kitchen Staff End */}
      {/* Section Best Start */}
      <section className="Best">
        <div className="container">
          <div className="text-center">
            <h1 className="i">Best Recipes</h1>
            <h2>AWARDED CHEFS</h2>
          </div>
          <div className="row py-5">
            <div className="col-lg-2"></div>
            <div className="col-lg-4 col-md-6">
              <h5 className="besttop">
                English Breakfast ..........{" "}
                <span style={{ float: "right" }}>$12.95</span>
              </h5>
              <hr />
              <p>
                Scrambled eggs with crispy bacon, sausage, black pudding, tomato
                & mushroom.
              </p>
            </div>
            <div className="col-lg-4 col-md-6">
              <h5 className="besttop">
                English Breakfast ..........{" "}
                <span style={{ float: "right" }}>$12.95</span>
              </h5>
              <hr />
              <p>
                Scrambled eggs with crispy bacon, sausage, black pudding, tomato
                & mushroom.
              </p>
            </div>
            <div className="col-lg-2"></div>
            <div className="col-lg-2"></div>
            <div className="col-lg-4 col-md-6">
              <h5 className="besttop">
                English Breakfast ..........{" "}
                <span style={{ float: "right" }}>$12.95</span>
              </h5>
              <hr />
              <p>
                Scrambled eggs with crispy bacon, sausage, black pudding, tomato
                & mushroom.
              </p>
            </div>
            <div className="col-lg-4 col-md-6">
              <h5 className="besttop">
                English Breakfast ..........{" "}
                <span style={{ float: "right" }}>$12.95</span>
              </h5>
              <hr />
              <p>
                Scrambled eggs with crispy bacon, sausage, black pudding, tomato
                & mushroom.
              </p>
            </div>
          </div>
          <div className="text-center">
            <button className="btn-now">ORDER NOW</button>
          </div>
        </div>
      </section>
      {/* Section Best End */}
      {/* Section Latest News Start */}
      <section className="latest">
        <div className="container">
          <div className="text-center py-5">
            <h1 className="i" style={{ fontSize: "50px" }}>
              Latest News
            </h1>
            <h1 style={{ color: "#e25111" }}>DELICIOUS RECIPES</h1>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-4 text-center">
              <div className="card">
                <img
                  src="assets\img\s4.jpg"
                  alt=""
                  className="img-fluid img-thumbnail"
                />
                <h2 className="pt-2">Brownies and Coffee</h2>
                <p className="p-2">
                  Brownies are chocolaty baked products made in square or
                  rectangle shapes. They are commonly consumed around the world
                  and are made with flour, fat (oil or butter), sugar, eggs and
                  chocolate (molten or cocoa powder).
                </p>

                <button className="btn-now mb-2">Discover More</button>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 text-center">
              <div className="card">
                <img
                  src="assets\img\a2.jpg"
                  alt=""
                  className="img-fluid img-thumbnail"
                />
                <h2>Buffet Service</h2>
                <p className="p-2">
                  A buffet can be either a sideboard (a flat-topped piece of
                  furniture with cupboards and drawers, used for storing
                  crockery, glasses, and table linen) or a system of serving
                  meals in which food is placed in a public area where the
                  diners serve themselves
                </p>

                <button className="btn-now mb-2">Discover More</button>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 text-center">
              <div className="card">
                <img
                  src="assets\img\a1.jpg"
                  alt=""
                  className="img-fluid img-thumbnail"
                />
                <h2 className="pt-2">Semi-self service</h2>
                <p className="p-2">
                  Self-service is the practice of serving oneself, usually when
                  making purchases.[1] Aside from Automated Teller Machines,
                  which are not limited to banks, and customer-operated
                  supermarket check-out,[2] labor-saving of which has been
                </p>

                <button className="btn-now mb-2">Discover More</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Section Latest News End */}
      {/* Section Revieu Start */}
      <section className="reviue">
        <div className="container">
          <h1 className="text-center">Our happy Customers</h1>
          <hr />
          <OwlCarousel items={1} className="owl-theme" loop margin={10} nav>
            <div className="item text-center">
              <i className="bi bi-1-circle"></i>
              <p className="lead col-lg-8 offset-lg-2">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit
                maxime sit suscipit sit amet consectetur adipisicing elit.
                Impedit maxime sit suscipit cum officiis omnis architecto
                nostrum magnam recusandae assumenda.
              </p>
            </div>
            <div className="item text-center">
              <i className="bi bi-2-circle"></i>
              <p className="lead col-lg-8 offset-lg-2">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit
                maxime sit suscipit sit amet consectetur adipisicing elit.
                Impedit maxime sit suscipit cum officiis omnis architecto
                nostrum magnam recusandae assumenda.
              </p>
            </div>
            <div className="item text-center">
              <i className="bi bi-3-circle"></i>
              <p className="lead col-lg-8 offset-lg-2">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit
                maxime sit suscipit sit amet consectetur adipisicing elit.
                Impedit maxime sit suscipit cum officiis omnis architecto
                nostrum magnam recusandae assumenda.
              </p>
            </div>
          </OwlCarousel>
        </div>
      </section>
      {/* Section Revieu End */}
      {/* Section contact Start */}
      <section class="contact">
        <div class="container" data-aos="fade-up">
          <header class="section-header">
            <h1 className="py-3 text-center" style={{ color: "#e25111" }}>
              Contact
            </h1>
          </header>

          <div class="row gy-4">
            <div class="col-lg-6">
              <div class="row gy-4">
                <div class="col-md-6">
                  <div class="info-box">
                    <i class="bi bi-geo-alt"></i>
                    <h3 style={{ color: "#e25111" }}>Address</h3>
                    <p>
                      Modal Town :
                      <br />M Block 483 Punjab Pakistan
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-box">
                    <i class="bi bi-telephone"></i>
                    <h3 style={{ color: "#e25111" }}>Call Us</h3>
                    <p>
                      +92 323 4240630
                      <br />
                      +92 301 8476693
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-box">
                    <i class="bi bi-envelope"></i>
                    <h3 style={{ color: "#e25111" }}>Email Us</h3>
                    <p>
                      info@example.com
                      <br />
                      contact@example.com
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-box">
                    <i class="bi bi-clock"></i>
                    <h3 style={{ color: "#e25111" }}>Open Hours</h3>
                    <p>
                      Monday - Friday
                      <br />
                      9:00AM - 05:00PM
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <form action=" " method=" " class="php-email-form">
                <div class="row gy-4">
                  <div class="col-md-6">
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder="Your Name"
                      required
                    />
                  </div>

                  <div class="col-md-6">
                    <input
                      type="email"
                      class="form-control"
                      name="email"
                      placeholder="Your Email"
                      required
                    />
                  </div>

                  <div class="col-md-12">
                    <input
                      type="text"
                      class="form-control"
                      name="subject"
                      placeholder="Subject"
                      required
                    />
                  </div>

                  <div class="col-md-12">
                    <textarea
                      class="form-control"
                      name="message"
                      rows="6"
                      placeholder="Message"
                      required
                    ></textarea>
                  </div>

                  <div class="col-md-12 text-center">
                    <div class="loading">Loading</div>
                    <div class="error-message"></div>
                    <div class="sent-message">
                      Your message has been sent. Thank you!
                    </div>

                    <button className="btn-now">SUBMIT</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Section contact End */}
    </>
  );
};

export default Home;
